var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    [
      _vm.source !== null
        ? _c(
            "field",
            {
              staticClass: "pb-2",
              attrs: {
                label: "Product Name",
                "error-text": _vm.showValidations ? _vm.validations.name : "",
              },
            },
            [
              _c("dropdown-field", {
                attrs: {
                  "no-items-found-text": "NO PRODUCTS FOUND",
                  "taggable-no-items-found-text":
                    "ADD NEW PRODUCT WITH ENTER OR",
                  "taggable-add-item-text": "ADD PRODUCT",
                  placeholder: "-- Select Product Or Type New Product --",
                  source: _vm.source,
                  "text-field": "name",
                  taggable: "",
                },
                on: {
                  "add-tag": function ($event) {
                    return _vm.addNewProduct($event)
                  },
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Product Description",
            "error-text": _vm.showValidations
              ? _vm.validations.description
              : "",
          },
        },
        [
          _c("text-field", {
            model: {
              value: _vm.description,
              callback: function ($$v) {
                _vm.description = $$v
              },
              expression: "description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Add New Product")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }